"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-nested-ternary */
var icons_1 = require("@ant-design/icons");
var react_1 = __importDefault(require("react"));
var reactjs_popup_1 = __importDefault(require("reactjs-popup"));
require("reactjs-popup/dist/index.css");
var styled_components_1 = __importStar(require("styled-components"));
var StyledCloseButton = styled_components_1.default(icons_1.CloseOutlined)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: white;\n  background: #333333;\n  border-radius: 50%;\n  padding: 11px;\n  position: absolute;\n  right: -19px;\n  top: -19px;\n"], ["\n  color: white;\n  background: #333333;\n  border-radius: 50%;\n  padding: 11px;\n  position: absolute;\n  right: -19px;\n  top: -19px;\n"])));
var Popup = function (_a) {
    var open = _a.open, onClose = _a.onClose, className = _a.className, children = _a.children, onClickClose = _a.onClickClose;
    return (react_1.default.createElement(reactjs_popup_1.default, { modal: true, open: open, onClose: onClose, className: className, closeOnDocumentClick: false },
        react_1.default.createElement(StyledCloseButton, { onClick: onClickClose || onClose }),
        children));
};
Popup.defaultProps = {
    open: false,
    onClose: undefined,
    className: undefined,
    maxWidth: undefined,
    onClickClose: undefined,
};
exports.default = styled_components_1.default(Popup)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &-content {\n    border-radius: 4px 0 4px 4px;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);\n\n    @media only screen and (max-width: 800px) {\n      width: 90%;\n    }\n\n    ", "\n  }\n"], ["\n  &-content {\n    border-radius: 4px 0 4px 4px;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);\n\n    @media only screen and (max-width: 800px) {\n      width: 90%;\n    }\n\n    ",
    "\n  }\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        max-width: ", ";\n      "], ["\n        max-width: ", ";\n      "])), maxWidth || '580px');
});
var templateObject_1, templateObject_2, templateObject_3;
